import { usePageMeta } from "@/utils/pageMeta";
import { Reveal } from "@/components/Reveal";

const Section = ({ title, children }) => (
  <section className="mt-10">
    <h2 className="text-lg font-bold text-navy">{title}</h2>
    <div className="mt-3 space-y-3 text-sm leading-relaxed text-navy/65">{children}</div>
  </section>
);

const Placeholder = ({ children }) => (
  <p className="rounded-xl border border-dashed border-brand/30 bg-brand/5 px-4 py-3 text-sm font-medium text-brand">
    {children}
  </p>
);

export const LegalLayout = ({ eyebrow, title, updated, children, testid }) => (
  <div data-testid={testid} className="pt-32 pb-24 sm:pt-40">
    <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="text-xs font-bold uppercase tracking-[0.22em] text-brand">{eyebrow}</p>
        <h1 className="mt-4 text-4xl font-extrabold tracking-tight text-navy sm:text-5xl">{title}</h1>
        <p className="mt-3 text-xs font-medium text-navy/40">Dernière mise à jour : {updated}</p>
        <div className="mt-10 rounded-3xl border border-slate-200 bg-white p-7 shadow-soft sm:p-10">{children}</div>
      </Reveal>
    </div>
  </div>
);

export { Section, Placeholder };
